import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { ThemeProvider } from '@mui/material/styles';

import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import { msalConfig } from './msalConfig';
import { PropertyProvider } from './contexts/PropertyContext';
import { GlobalStyles } from './theme/GlobalStyles';  // <-- Our new global style
import theme from './theme';
import './i18n';
import { initializeMsalInstance } from './services/msalInstanceManager';

// Create MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL before rendering (handles redirect promise ONCE)
msalInstance.initialize().then(async () => {
  // Handle redirect and set active account (single source of truth)
  await initializeMsalInstance(msalInstance);
  
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <MsalProvider instance={msalInstance}>
        <PropertyProvider>
          <Router>
            <App />
          </Router>
        </PropertyProvider>
      </MsalProvider>
    </ThemeProvider>
  );
});

reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// Register service worker in both development and production
// but with different configurations
serviceWorker.register({
  onUpdate: (registration) => {
    console.log('New content is available; please refresh.');
    // You could show a toast or notification here
  },
  onSuccess: (registration) => {
    console.log('Content is cached for offline use.');
  },
});
